import axios from "axios"

export default async function GetHoodList() {
    let request = async () => {
        try {
            const response = await axios.get('https://oxx-api.vercel.app/faiimoveis/imoveis/bairroslist/', {
                headers: { 'api-key': 'xUp2jAz5hQZM#wCsKb' }
            })
            return (response.data)
        } catch (error) {
            console.error('Erro ao Definir Lista de Bairros: ', error)
        }
    }

    return Promise.resolve(request)
}